/**
 * presetRecency — tiny shared cache for "recently played" preset IDs.
 *
 * The cache is read by PresetManagementPanel (to render the pinned
 * "Recently used" section) and written by BrainwaveGenerator the moment
 * the user actually hits Play with a preset loaded. Updating it only on
 * Play (rather than on preset *selection*) gives a cleaner signal:
 * window-shopping through 10 presets doesn't inflate the recency list.
 */

const PRESET_RECENT_KEY = 'neurowave_preset_recent';
const RECENT_MAX = 3;

export const readRecent = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(PRESET_RECENT_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string').slice(0, RECENT_MAX) : [];
  } catch {
    return [];
  }
};

/**
 * Record a preset as just-used. Move-to-front semantics (if already in
 * the list, it floats to the top), cap at RECENT_MAX. Returns the new
 * list so callers using React state can do `setRecent(pushRecent(...))`.
 */
export const pushRecent = (presetId, currentList = readRecent()) => {
  if (!presetId) return currentList;
  const next = [presetId, ...currentList.filter((id) => id !== presetId)].slice(0, RECENT_MAX);
  try { localStorage.setItem(PRESET_RECENT_KEY, JSON.stringify(next)); } catch { /* ignore */ }
  return next;
};

export { PRESET_RECENT_KEY, RECENT_MAX };
